//const APPS_SCRIPT_URL =
//  'https://script.google.com/macros/s/AKfycbw3-U0rb2W-BFfuyp-a1QHSpWT2_BpJB4auwNCKoAgQE6slf6o93cn014uvzV2zLJh2Dg/exec';

const APPS_SCRIPT_URL = 'https://namesapi.njjamaat.org/names-data';

let namesDataPromise = null;

export function getNamesData() {
  if (namesDataPromise) {
    return namesDataPromise;
  }

  namesDataPromise = fetch(APPS_SCRIPT_URL)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Failed to fetch names data');
      }

      return response.json();
    })
    .catch((error) => {
      namesDataPromise = null;
      throw error;
    });

  return namesDataPromise;
}

export async function getCommitteeData() {
  const data = await getNamesData();

  return {
    anjuman: data.anjuman || [],
    umoor: data.umoor || {},
    sansthas: data.sansthas || [],
  };
}

export async function getKhidmatGuzarData() {
  const data = await getNamesData();

  return data.khidmatGuzar || {};
}